<script>
    import locationsStore from "../stores/locationsStore";
    import LocationsTreeNode from "./LocationsTreeNode.svelte";

    let showSidebar = false;
    let selected = null;

    const onCancel = () => {
        locationsStore.close();
        $locationsStore.tree = $locationsStore.tree;
        showSidebar = false;
    }

    const onEdit = () => {

    }

    const onSelect = ({detail:location}) => {
        if ($locationsStore.multi_select) {
            if (!selected) {
                selected = [];
            }
        }
        locationsStore.close(location.id);
        $locationsStore.tree = $locationsStore.tree;
        showSidebar = false;
    }

    $: {
        if ($locationsStore.tree) {
            if (!selected) selected = [];
            showSidebar = true;
        }
    }
</script>

{#if showSidebar}
    <div class="locations-sidebar">
        <div class="locations-sidebar-header" on:click="{ onCancel }">
            kokolala
        </div>
        <div class="locations-sidebar-body">
            {#each $locationsStore.tree as location}
                <LocationsTreeNode location="{ location }" on:edit="{ onEdit }" on:select="{ onSelect }"/>
            {/each}
        </div>
    </div>
{/if}

<style>
    .locations-sidebar {
        position: fixed;
        top: 0px;
        bottom: 0px;
        right: 0px;
        width: 300px;
        background: rgb(204, 204, 204);
        z-index: 6000;
    }
    .locations-sidebar-header {

    }
    .locations-sidebar-body {

    }
</style>